import { Classes, Dialog } from "@blueprintjs/core"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon"
import React from "react"
import { SystemColumns } from "../models/board"
import { QuestionCardType } from "../models/card"
import styles from "./ReadinessConfirmDialog.module.scss"

/**
 * Отметка выполнения за всех исполнителей. Из работы и просрочки задание при этом
 * уходит на проверку — об этом предупреждаем, иначе перенос выглядит неожиданным
 */
export const ReadinessConfirmDialog: React.FC<ReadinessConfirmDialogProps> = ({
  card,
  reviewColumn,
  onConfirm,
  onCancel,
}) => {
  // из «На проверке» и «Исполнено» задание никуда не двигается
  const moves =
    !!reviewColumn && card.columnId !== SystemColumns.review && card.columnId !== SystemColumns.done

  const people = card.implementers.length > 0 ? card.implementers : card.employers

  return (
    <Dialog
      isCloseButtonShown={true}
      isOpen={true}
      onClose={onCancel}
      title="Отметить выполненным"
      backdropClassName="standard"
      className={`figma-dialog ${styles.dialog}`}
    >
      <div className={styles.body}>
        <div className={styles.question} title={card.title}>
          <span className={styles.number}>{card.number}</span>
          {card.label}
        </div>

        <div className={styles.notice}>
          <GeneralIcon type="general-exclamation" size={16} />
          <span>
            Задание будет отмечено выполненным за всех исполнителей
            {moves ? ` и перенесено в «${reviewColumn}»` : ""}.
          </span>
        </div>

        {people.length > 0 && (
          <div className={styles.people}>
            {people.map((person) => (
              <div className={styles.person} key={person.id}>
                {person.name}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={Classes.DIALOG_FOOTER}>
        <div className={styles.footer}>
          <PlanrButton type="greenish" onClick={onConfirm}>
            Отметить
          </PlanrButton>
          <PlanrButton type="graybtn" onClick={onCancel}>
            Отмена
          </PlanrButton>
        </div>
      </div>
    </Dialog>
  )
}

interface ReadinessConfirmDialogProps {
  card: QuestionCardType
  /** Название колонки «На проверке» на этой доске. Пусто — переносить некуда */
  reviewColumn: string
  onConfirm: () => void
  onCancel: () => void
}
